import React, { FC } from 'react';
import {
  Container,
  Title,
} from '@/components/profileDetail/profileBody/overviewTab/ratingsAndReviews/ratingsAndReviews.sc';
import { RatingsSection } from '@/components/profileDetail/profileBody/overviewTab/ratingsAndReviews/ratingsSection/RatingsSection';
import { ActionButtons } from '@/components/ratingAndReview/actionButtons/ActionButtons';
import { NoRatingsSection } from '@/components/ratingAndReview/noRatingsSection/NoRatingsSection';
import { IAppRating } from '@/types';

export interface IRatingsAndReviewsProps {
  ratings?: IAppRating;
}

export const RatingsAndReviews: FC<IRatingsAndReviewsProps> = ({ ratings }) => {
  return (
    <Container>
      <Title data-test-automation-id={'ratings-and-review-title'}>
        RATINGS AND REVIEWS
      </Title>
      {ratings ? <RatingsSection ratings={ratings} /> : <NoRatingsSection />}
      <ActionButtons />
    </Container>
  );
};
